import { render, staticRenderFns } from "./CreateDireccion.vue?vue&type=template&id=6418c943&scoped=true&"
import script from "./CreateDireccion.vue?vue&type=script&lang=js&"
export * from "./CreateDireccion.vue?vue&type=script&lang=js&"
import style0 from "./CreateDireccion.vue?vue&type=style&index=0&id=6418c943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418c943",
  null
  
)

export default component.exports